import {StyleSheet} from 'react-native';

import {black, cloudLight, white} from '/theme/color/on.color';

const styles = StyleSheet.create({
  footer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: white,
    paddingHorizontal: 20,
    paddingTop: 28,
    // paddingBottom: 20,
    borderTopWidth: 1,
    borderTopColor: cloudLight,
    shadowColor: black,
    shadowOffset: {width: 0, height: -3},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 8,
  },

  cancelButton: {
    flex: 1,
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
    borderRadius: 6,
  },

  cancelText: {
    color: '#303030',
    fontSize: 18,
  },

  saveButton: {
    flex: 1,
    height: 48,
    backgroundColor: '#2C2C2C',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 8,
    borderRadius: 30,
  },

  saveText: {
    color: '#F5F5F5',
    fontWeight: '700',
    fontSize: 18,
  },

  disabledBtn: {
    backgroundColor: '#D0D5DD',
    borderRadius: 30,
  },
  disabledText: {
    color: '#667085',
    fontWeight: '700',
    fontSize: 18,
  },
  cancelButtonCompact: {
    minHeight: 40,
    paddingVertical: 8,
  },
  saveButtonCompact: {
    minHeight: 40,
    paddingVertical: 8,
  },
  footerCompact: {
    paddingTop: 8,
  },
  fullWidthSaveButton: {
    flex: 1,
    width: '100%',
  },
  fullWidth: {
    width: '100%',
    textAlign: 'center',
  },
});

export default styles;
